<template>
    <!-- 全局toast -->
    <div id="toast" class="toast d-flex-y fixed f13" :class="{ show: appStore.toastVisible }">
        <span id="toastMsg">{{ appStore.toastMessage }}</span>
    </div>
</template>

<script setup lang="ts">
const appStore = useAppStore();
</script>

<style lang="less" scoped>
.toast {
    bottom: 28px;
    right: 28px;
    background: #323130;
    color: white;
    border-radius: 8px;
    padding: 12px 18px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .25);
    z-index: 10000;
    transform: translateY(100px);
    opacity: 0;
    transition: transform .3s, opacity .3s;
    gap: 10px;

    &.show {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
